module.exports = __webpack_public_path__ + "img/dartmouth-logo.e5c5e571.png";